/**
 * Renderiza o texto markdown-lite dos documentos legais (Termos de Uso /
 * Política de Privacidade, ver PlatformLegal.vue) em HTML — formato mínimo,
 * de propósito: "## " vira título de seção, "- " vira item de lista, resto
 * vira parágrafo. Sem negrito/itálico/links — é tudo que o conteúdo real
 * desses documentos usa hoje.
 *
 * Escapa entidades HTML antes de envolver nas tags: o texto é editável só
 * por PLATFORM_OWNER, mas é exibido via v-html em página pública sem
 * autenticação — defesa em profundidade.
 * @param {string} text
 * @returns {string}
 */
export function renderLegalMarkdown(text) {
  const escapeHtml = (s) => s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  const blocks = String(text || '').split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean)

  return blocks.map((block) => {
    if (block.startsWith('## ')) {
      return `<h2 class="text-lg font-semibold text-zinc-900 dark:text-white mt-6 mb-2">${escapeHtml(block.slice(3).trim())}</h2>`
    }

    const lines = block.split('\n').map((l) => l.trim()).filter(Boolean)
    if (lines.length && lines.every((l) => l.startsWith('- '))) {
      const items = lines.map((l) => `<li>${escapeHtml(l.slice(2).trim())}</li>`).join('')
      return `<ul class="mt-2 list-inside list-disc space-y-1 leading-7 text-zinc-700 dark:text-zinc-300">${items}</ul>`
    }

    return `<p class="mt-2 leading-7 text-zinc-700 dark:text-zinc-300">${escapeHtml(block).replace(/\n/g, ' ')}</p>`
  }).join('')
}
